import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle, FaSignOutAlt } from "react-icons/fa";
import { motion } from "framer-motion";

export default function AwaitingActivation() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#363062]/5 to-[#8FCD00]/5 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center"
      >
        <div className="flex justify-center mb-6">
          <motion.div
            animate={{ scale: [1, 1.1, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            <FaCheckCircle className="text-[#8FCD00] text-5xl" />
          </motion.div>
        </div>

        <h2 className="text-[#363062] text-lg font-semibold mb-3">
          Account Created Successfully!
        </h2>

        <p className="text-gray-600 mb-6">
          Your account has been created. Please wait while we activate your
          access rights. We'll notify you once everything is ready.
        </p>

        <div className="space-y-4">
          <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
            <div className="w-2 h-2 rounded-full bg-[#8FCD00] animate-pulse"></div>
            <span>Activation in progress</span>
          </div>

          <button
            className="w-full flex items-center justify-center space-x-2 bg-[#363062] hover:bg-[#363062]/90 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200"
            onClick={() => navigate("/login")}
          >
            <FaSignOutAlt />
            <span>Log Out</span>
          </button>
        </div>
      </motion.div>
    </div>
  );
}
